"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectCell = exports.SelectOptionsCell = void 0;
const react_1 = __importStar(require("react"));
const inline_table_field_cells_1 = require("../../../components/inline-table-field/inline-table-field-cells");
const list_source_hook_1 = require("../../../utils/list-source-hook");
function SelectOptionsCell({ collectionDatakey, ...inlineProps }) {
    const SelectCell = (props) => {
        const useDefaultSource = () => {
            var _a, _b;
            return (0, list_source_hook_1.useStaticListSource)((_b = (_a = props.rowValue.options) === null || _a === void 0 ? void 0 : _a.map((option) => typeof option === 'string' ? { id: option } : option)) !== null && _b !== void 0 ? _b : []);
        };
        const Cell = inline_table_field_cells_1.InlineTableFieldCells.useInlineSelectCellFactory({
            ...inlineProps,
            dataHook: useDefaultSource,
            valueIsId: true,
            labelMapper: (option) => { var _a; return (_a = option === null || option === void 0 ? void 0 : option.name) !== null && _a !== void 0 ? _a : option.id; },
            collectionDatakey,
        });
        return react_1.default.createElement(Cell, { ...props });
    };
    return (0, react_1.useMemo)(() => SelectCell, [collectionDatakey]);
}
exports.SelectOptionsCell = SelectOptionsCell;
function SelectCell(props) {
    return function useCell({ collectionDatakey, ...inlineProps }) {
        const SelectCell = inline_table_field_cells_1.InlineTableFieldCells.useInlineSelectCellFactory({
            ...props,
            ...inlineProps,
            collectionDatakey,
        });
        return (0, react_1.useMemo)(() => SelectCell, [collectionDatakey, props]);
    };
}
exports.SelectCell = SelectCell;
//# sourceMappingURL=select-cell.js.map